export const guestAccessTypes = {
    loading: "LOADING_GUESTACCESS",
    delete: "DELETE_GUESTACCESS",
    loadedOne: "LOADED_GUESTACCESS",
    loadedMultiple: "LOADED_GUESTACCESSS",
    success: "SUCCESS_GUESTACCESS",
    restore: "RESTORE_GUESTACCESS",
    hardDelete: "HARDDELETE_GUESTACCESS",
};
